var map = {
	"./makhana-pudina-punch (1).png": 4018,
	"./makhana-pudina-punch (2).png": 9923,
	"./makhana-pudina-punch (3).png": 8684,
	"./makhana-pudina-punch (4).png": 3509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4110;